<template>
	<Card bordered size="large">
		<template #header>
			<div class="flex flex-wrap items-start justify-between gap-x-4 gap-y-1">
				<div class="text-fs-base font-medium">
					{{ $t(`dashboard.upcoming_deliveries_title`, { count: DAYS_BACK }) }}
				</div>

				<div
					v-if="totalCount"
					class="text-fs-sm text-right font-normal"
					v-html="$t(`dashboard.upcoming_deliveries_count`, { count: totalCount })"
				></div>
			</div>
		</template>

		<DataList
			class="pt-1"
			:filters="{ deliveringIn: DAYS_BACK, status: 'PREGNANCY' }"
			:sort="{ key: 'delivery_date', direction: 'asc' }"
			:use-pagination="false"
			:page-size="1000"
			hide-patient-status
			empty-class="py-0!"
			@list="list = $event"
			@total-count="totalCount = $event"
		>
			<template #empty>
				<Card
					embedded
					size="small"
					class="min-h-70"
					content-class="flex flex-col items-center justify-center gap-6"
				>
					<div class="bg-grey-100 flex size-12 items-center justify-center rounded-full">
						<PatientStatusIcon :meta="{ status: 'PREGNANCY' }" :size="24" />
					</div>
					<div class="flex flex-col items-center justify-center gap-1">
						<div class="text-fs-md text-secondary font-medium">
							{{ $t(`dashboard.no_upcoming_deliveries_title`) }}
						</div>
						<div class="text-fs-md text-secondary">
							{{ $t(`dashboard.no_upcoming_deliveries_description`) }}
						</div>
					</div>
					<div>
						<JMButton
							type="primary"
							size="large"
							@click="routePatients({ patientId: 'create' }).navigate()"
						>
							<template #icon>
								<Icon name="carbon:face-add" />
							</template>
							<span>{{ $t(`patients.common.create_new_patient`) }}</span>
						</JMButton>
					</div>
				</Card>
			</template>
		</DataList>
	</Card>
</template>

<script lang="ts" setup>
import type { Patient } from "@/types/patient"
import { ref } from "vue"
import Card from "@/components/common/Card.vue"
import Icon from "@/components/common/Icon.vue"
import JMButton from "@/components/common/JMButton.vue"
import DataList from "@/components/patient/DataList/DataList.vue"
import PatientStatusIcon from "@/components/patient/PatientStatusIcon.vue"
import { useNavigation } from "@/composables/router/useNavigation"

const { routePatients } = useNavigation()

const DAYS_BACK = 90

const totalCount = ref(0)
const list = ref<Patient[]>([])
</script>
